import { isPlatformBrowser } from '@angular/common';
import { Component, Inject, OnInit, PLATFORM_ID, signal } from '@angular/core';
import { Router } from '@angular/router';

declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void;
  }
}

@Component({
  selector: 'app-cookie',
  imports: [],
  templateUrl: './cookie.component.html',
  styleUrl: './cookie.component.scss',
})
export class CookieComponent implements OnInit {
  readonly isVisible = signal(false);

  private readonly COOKIE_KEY = 'cookieConsent';
  private readonly COOKIE_EXPIRY_HOURS = 24;
  private readonly isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) platformId: object,
    private readonly router: Router,
  ) {
    this.isBrowser = isPlatformBrowser(platformId);
  }

  ngOnInit(): void {
    if (!this.isBrowser) return;

    try {
      const parsed = JSON.parse(localStorage.getItem(this.COOKIE_KEY) ?? 'null') as {
        timestamp?: number;
      } | null;
      const valid =
        parsed &&
        typeof parsed.timestamp === 'number' &&
        Date.now() < parsed.timestamp + this.COOKIE_EXPIRY_HOURS * 3600_000;

      if (!valid) localStorage.removeItem(this.COOKIE_KEY);
      this.isVisible.set(!valid);
    } catch {
      localStorage.removeItem(this.COOKIE_KEY);
      this.isVisible.set(true);
    }
  }

  acceptCookies(): void {
    this.handleConsent(true);
  }

  rejectCookies(): void {
    this.handleConsent(false);
  }

  private handleConsent(accepted: boolean): void {
    if (this.isBrowser) {
      localStorage.setItem(
        this.COOKIE_KEY,
        JSON.stringify({
          value: accepted ? 'granted' : 'denied',
          timestamp: Date.now(),
        }),
      );

      const state = accepted ? 'granted' : 'denied';
      window.gtag?.('consent', 'update', {
        analytics_storage: state,
        ad_storage: 'denied',
        ad_user_data: 'denied',
        ad_personalization: 'denied',
      });
    }

    this.isVisible.set(false);
  }

  onNavigateLink(route: string, event?: Event): void {
    event?.preventDefault();
    if (this.router.url.split('?')[0] !== route) {
      void this.router.navigateByUrl(route);
    }
  }
}
